module.exports = __webpack_public_path__ + "static/media/join-hours-new.0afac296.svg";